import * as React from 'react';
import { MouseEvent, ReactNode, useCallback, useState } from 'react';

import { useStores } from 'hooks';
import { getAtlasPartnerizeTrackingLink, Link, getAtlasDirectTrackingLink } from 'modules/tracking';
import { getLinkUrl, useBannersContext } from 'features/banners';
import { ClientLogger } from 'bernie-client';

interface LinkProps {
  children: ReactNode;
}

const logger = ClientLogger.getLoggerWithIdentifier('product.banners.link');

function Link(props: LinkProps): JSX.Element {
  const { children } = props;
  const {
    app: {
      tracking,
      program,
      productId,
      network: { id: networkId },
    },
  } = useStores();
  const { linkId } = useBannersContext();
  const [savedUrl, setSavedUrl] = useState('');

  const getAtlasPartnerizeUrl = useCallback(
    async (linkUrl) => {
      const atlasResponse = await getAtlasPartnerizeTrackingLink({
        tracking: tracking,
        landingPages: [
          {
            label: productId,
            url: linkUrl,
            generateShortLink: false,
          },
        ],
        logger,
      });

      return (atlasResponse && atlasResponse[0]?.url) || linkUrl;
    },
    [tracking, productId]
  );

  const getAtlasDirect = useCallback(
    async (linkUrl) => {
      const atlasResponse = await getAtlasDirectTrackingLink({
        mdpcid: tracking.mdpcid,
        landingPages: [
          {
            label: productId,
            url: `${linkUrl}&mdpcid=${tracking.mdpcid}`,
          },
        ],
        logger,
      });

      return (atlasResponse && atlasResponse[0]?.url) || linkUrl;
    },
    [tracking?.mdpcid, productId]
  );

  async function handleClick(event: MouseEvent) {
    event.preventDefault();

    // Setup empty popup early after user interaction to prevent browser block
    window['popup'] = window.open('', '_blank');

    // TODO: Add analytics

    let url = savedUrl;
    if (!url) {
      const linkUrl = getLinkUrl({ programId: program?.id, linkId });
      switch (networkId) {
        case 'direct':
          url = await getAtlasDirect(linkUrl);
          break;
        case 'pz':
          url = await getAtlasPartnerizeUrl(linkUrl);
          break;
        default:
          url = linkUrl;
          break;
      }
      setSavedUrl(url);
    }

    // Update popup with generated Search URL. This works around a Safari quirk.
    window['popup'].location.assign(url);
  }

  return (
    <a className="link" href="" target="_blank" rel="noreferrer" onClick={handleClick}>
      {children}
    </a>
  );
}

export { Link };
